import { db } from "@/main";
import { Mailbox } from "../models/Mailbox";
import { getClientRef } from "./ClientRepository";

function getMailboxCollectionRef() {
  return db.doc(getClientRef()).collection("mailboxes");
}

function getMailboxRef(mailbox: Mailbox) {
  return getMailboxCollectionRef().doc(mailbox.id);
}

export async function doesOtherMailboxWithNameExist(
  mailbox: Mailbox
): Promise<boolean> {
  const result = await getMailboxCollectionRef()
    .where("name", "==", mailbox.name)
    .limit(2)
    .get();

  return result.docs
    .map((doc) => doc.data() as Mailbox)
    .some((storedMailbox) => storedMailbox.id !== mailbox.id);
}

export async function saveMailbox(mailbox: Mailbox) {
  return getMailboxRef(mailbox).set(mailbox, { merge: true });
}

export async function deleteMailbox(mailboxId: string) {
  return getMailboxCollectionRef()
    .doc(mailboxId)
    .delete();
}

export function observeMailboxesOfClient(
  onNext: (mailboxes: Mailbox[]) => void
) {
  return getMailboxCollectionRef().onSnapshot((snapshot) => {
    const mailboxes = snapshot.docs
      .map((doc) => doc.data() as Mailbox)
      .sort((a, b) => a.name.localeCompare(b.name));

    onNext(mailboxes);
  });
}

export function observeMailbox(
  mailboxId: string,
  onNext: (mailbox: Mailbox) => void
) {
  return getMailboxCollectionRef()
    .where("id", "==", mailboxId)
    .limit(1)
    .onSnapshot((snapshot) => {
      const mailboxes = snapshot.docs
        .map((doc) => doc.data() as Mailbox)
        .sort((a, b) => a.name.localeCompare(b.name));

      const mailbox = mailboxes[0]

      if (mailbox) {
        onNext(mailbox);
      }
    });
}

export function observeMailboxesOfUser(
  userId: string,
  onNext: (mailboxes: Mailbox[]) => void
) {
  return getMailboxCollectionRef()
    .where("showMessageToUserIds", "array-contains", userId)
    .onSnapshot((snapshot) => {
      const mailboxes = snapshot.docs
        .map((doc) => doc.data() as Mailbox)
        .sort((a, b) => a.name.localeCompare(b.name));

      onNext(mailboxes);
    });
}
